import * as React from "react";
import DateTemplate from "../../../ui/templates/columns/DateTemplate";
import NameTemplate from "../../../ui/templates/columns/NameTemplate";
import PrwcDataTableBasic from "../../../ui/widgets/custom/PrwcDataTableBasic";

const ProfileGroups = () => {

  const data = [
    {
      id: 1,
      name: "selection_One",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 2,
      name: "selection_two",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 3,
      name: "selection_three",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 4,
      name: "selection_four",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
  ];

  const dataTable = {
    columns: [
      {
        field: "group",
        headerLabelKey: "users.label.group",
        bodyTemplate: NameTemplate,
        templateArgument: "name",
        className: "w-44 text-xs font-semibold text-blue-700",
      },
      {
        field: "validFrom",
        headerLabelKey: "users.label.validFrom",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "validTo",
        headerLabelKey: "users.label.validTo",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
    ],
  };

  return (
    <>
      <PrwcDataTableBasic
        data={data}
        columns={dataTable.columns}
      ></PrwcDataTableBasic>
    </>
  );
};

export default ProfileGroups;
